export default __webpack_public_path__ + "static/media/antifreeze_sm.eb79b91d.webp";